/**
 * 环境判断
 */

const signBit = {
  // 是否显示 run btn
  run: Math.pow(2, 3),
  // 是否显示 test btn
  test: Math.pow(2, 4),
  // 是否显示save btn
  save: Math.pow(2, 5),
  // 是否显示answer list
  answers: Math.pow(2, 6),
  // 是否本地运行，python
  rlocal: Math.pow(2, 7),
  // 是否显示提交
  commit: Math.pow(2, 8),
  // 混合基数
  mixin: Math.pow(2, 12),
  getQueryIp: query => {
    let ideParams = 0
    // ip -- 标志位，取名ip为迷惑他人
    if (query && query.ip) {
      ideParams = parseInt(query.ip, 10) || 0
    }
    return ideParams
  }
}

const models = {
  edit: signBit.run + signBit.test + signBit.save + signBit.answers + signBit.mixin,
  preview: 0,
  judge: signBit.run + signBit.test + signBit.mixin,
}

export default {
  getIsTestEnv: () => {
    if (location.host.match(/(test\.|test-)/g)) {
      return true;
    }
    return false;
  },
  getIsDevEnv: () => {
    if (location.host.match(/(dev\.|dev-|local-)/g)) {
      return true;
    }
    return false;
  },
  models,
  signBit
};
